/**
 * @param {String} drawerId - the ID attribute of the drawer you want to display. Can be a data-drawer as well.
 * @param {Function} callback - if you want to trigger a specific action after the drawer is opened
 * @return {Promise | null}
 */
export async function showDrawer<T>(drawerId: string, callback?: () => T): Promise<void | null> {
    const drawer: HTMLJoyDrawerElement | null =
        document.body.querySelector(`#${drawerId}`) || document.body.querySelector(`[data-drawer="${drawerId}"]`);

    if (!drawer || drawer.tagName !== 'JOY-DRAWER') {
        console.error(`Unable to find any joy-drawer with ID nor data-id "${drawerId}"`);
        return null;
    }

    await (drawer as HTMLJoyDrawerElement)!.openDrawer(callback);
}

/**
 * @return {void}
 */
export function hideAllDrawers(): void {
    Array.from(document.querySelectorAll('joy-drawer')).map((drawer) => (drawer.open = false));
}
